var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Point of Sale","items":_vm.items,"doc":_vm.doc}},[_c('LoadPOS')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }